<template>
  <header class="site-header">
    <div class="header-inner">
      <div class="brand" @click="goHome">
        <img src="/brand-icon.png" alt="SignalRoom" class="brand-icon" />
        <div>
          <div class="brand-name">SignalRoom</div>
          <div class="brand-tag">signalroom.vip</div>
        </div>
      </div>

      <button class="mobile-toggle" @click="mobileOpen = !mobileOpen" aria-label="Menu">
        <span /><span /><span />
      </button>

      <nav class="nav-main" :class="{ open: mobileOpen }">
        <div
          v-for="cat in categories"
          :key="cat.id"
          class="nav-item"
          @mouseenter="hoverCat = cat.id"
          @mouseleave="hoverCat = null"
        >
          <button
            class="nav-cat-btn"
            :class="{ active: hoverCat === cat.id }"
            @click="toggleMobileCat(cat.id)"
          >
            <span class="cat-icon">{{ catIcon(cat.slug) }}</span>
            {{ shortName(cat.name) }}
            <span class="chevron">▾</span>
          </button>

          <div
            v-show="hoverCat === cat.id || mobileCat === cat.id"
            class="dropdown-panel"
          >
            <div class="dropdown-head">
              <strong>{{ cat.name }}</strong>
              <p>{{ cat.description }}</p>
            </div>
            <div class="dropdown-list">
              <button
                v-for="quiz in cat.quizzes"
                :key="quiz.id"
                class="dropdown-quiz"
                @click="pickQuiz(quiz.id)"
              >
                {{ quiz.name }}
                <span class="q-meta">{{ quiz.question_count || '—' }} Q · {{ quiz.duration_mins }}m</span>
              </button>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
const ICONS = {
  intelligence: '🧠',
  personality: '🎭',
  career: '💼',
  financial: '💰',
  emotional: '❤️',
  language: '🌐',
  reasoning: '⚖️',
  culture: '🏛️'
}

const SHORT = {
  'Intelligence & Cognition': 'Intelligence',
  'Personality & Traits': 'Personality',
  'Career & Development': 'Career',
  'Financial & Economics': 'Finance',
  'Emotional & Relationships': 'Relationships',
  'Language & Communication': 'Language',
  'Reasoning & Critical Thinking': 'Reasoning',
  'General Knowledge & Culture': 'Culture'
}

export default {
  name: 'AppHeader',
  props: {
    categories: { type: Array, default: () => [] }
  },
  data () {
    return {
      hoverCat: null,
      mobileOpen: false,
      mobileCat: null
    }
  },
  methods: {
    catIcon (slug) {
      return ICONS[slug] || '📋'
    },
    shortName (name) {
      return SHORT[name] || name.split(' ')[0]
    },
    goHome () {
      this.mobileOpen = false
      if (this.$route.name === 'Home') return
      this.$router.push({ name: 'Home' })
    },
    pickQuiz (id) {
      this.mobileOpen = false
      this.mobileCat = null
      this.hoverCat = null
      this.$router.push({ name: 'QuizLanding', params: { id: String(id) } })
    },
    toggleMobileCat (id) {
      if (window.innerWidth <= 960) {
        this.mobileCat = this.mobileCat === id ? null : id
      }
    }
  }
}
</script>

<style scoped>
.site-header {
  background: linear-gradient(135deg, #0a1628 0%, #0d1f3c 55%, #1a3a6b 100%);
  border-bottom: 1px solid rgba(255,255,255,0.08);
  position: sticky;
  top: 0;
  z-index: 200;
}

.header-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.brand {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0.75rem 0;
}

.brand-icon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: block;
  object-fit: cover;
  flex-shrink: 0;
}

.brand-name {
  font-family: 'Playfair Display', serif;
  font-size: 1.15rem;
  font-weight: 700;
  color: #fff;
}

.brand-tag {
  font-size: 0.62rem;
  color: rgba(255,255,255,0.5);
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.mobile-toggle {
  display: none;
  margin-left: auto;
  background: none;
  border: none;
  flex-direction: column;
  gap: 5px;
  padding: 0.5rem;
  cursor: pointer;
}

.mobile-toggle span {
  display: block;
  width: 22px;
  height: 2px;
  background: #fff;
  border-radius: 1px;
}

.nav-main {
  display: flex;
  flex: 1;
  justify-content: flex-end;
  gap: 0.15rem;
}

.nav-item {
  position: relative;
}

.nav-cat-btn {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  background: none;
  border: none;
  color: rgba(255,255,255,0.78);
  font-size: 0.8rem;
  padding: 1rem 0.65rem;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s;
}

.nav-cat-btn:hover,
.nav-cat-btn.active {
  color: #e8c547;
}

.cat-icon { font-size: 0.95rem; }
.chevron { font-size: 0.6rem; opacity: 0.6; }

.dropdown-panel {
  position: absolute;
  top: 100%;
  right: 0;
  min-width: 320px;
  max-width: 380px;
  background: #fff;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 16px 48px rgba(13,31,60,0.18);
  border: 1px solid #e8edf5;
  border-top: 3px solid #e8c547;
  z-index: 300;
}

.dropdown-head {
  padding: 1rem 1.15rem 0.75rem;
  border-bottom: 1px solid #f0f4fa;
}

.dropdown-head strong {
  display: block;
  font-family: 'Playfair Display', serif;
  font-size: 0.95rem;
  color: #0d1f3c;
  margin-bottom: 0.25rem;
}

.dropdown-head p {
  font-size: 0.72rem;
  color: #6b7fa0;
  line-height: 1.45;
}

.dropdown-list {
  max-height: 340px;
  overflow-y: auto;
  padding: 0.5rem;
}

.dropdown-quiz {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 0.65rem 0.75rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.78rem;
  color: #1a2744;
  line-height: 1.35;
  transition: background 0.15s;
}

.dropdown-quiz:hover {
  background: #f0f4fa;
  color: #1a3a6b;
}

.q-meta {
  font-size: 0.68rem;
  color: #9aaac0;
  margin-top: 0.2rem;
}

@media (max-width: 960px) {
  .mobile-toggle { display: flex; }

  .nav-main {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #0d1f3c;
    flex-direction: column;
    padding: 0.5rem 1rem 1rem;
    border-bottom: 1px solid rgba(255,255,255,0.1);
    max-height: 80vh;
    overflow-y: auto;
  }

  .nav-main.open { display: flex; }

  .nav-item { width: 100%; }

  .nav-cat-btn {
    width: 100%;
    justify-content: flex-start;
    padding: 0.85rem 0.5rem;
    color: rgba(255,255,255,0.85);
  }

  .dropdown-panel {
    position: static;
    min-width: 100%;
    max-width: 100%;
    box-shadow: none;
    border: none;
    border-radius: 8px;
    margin-bottom: 0.5rem;
    background: rgba(255,255,255,0.06);
  }

  .dropdown-head strong { color: #e8c547; }
  .dropdown-head p { color: rgba(255,255,255,0.55); }
  .dropdown-head { border-color: rgba(255,255,255,0.08); }

  .dropdown-quiz {
    color: rgba(255,255,255,0.85);
  }

  .dropdown-quiz:hover {
    background: rgba(255,255,255,0.08);
    color: #fff;
  }

  .q-meta { color: rgba(255,255,255,0.45); }
}
</style>
